<script setup>
import { ref, watch, computed, onMounted } from "vue";
import {
  Chart,
  RadarController,
  LineElement,
  PointElement,
  RadialLinearScale,
  //CategoryScale,
  Tooltip,
} from "chart.js";

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

const root = ref(null);

let chart;

Chart.register(
  RadarController,
  LineElement,
  PointElement,
  RadialLinearScale,
  //CategoryScale,
  Tooltip
);

onMounted(() => {
  chart = new Chart(root.value, {
    type: "radar",
    data: props.data,
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: { // <-- note change in options from scale to scales
        r: {
          grid: {
            circular: true,
            //display: false// LRR Oculta los círculos
          },
          beginAtZero: true
        }
      },
      plugins: {
        legend: {
          display: false,
        },
      },
    },
  });
});

const chartData = computed(() => props.data);

watch(chartData, (data) => {
  if (chart) {
    chart.data = data;
    chart.update();
  }
});
</script>

<template>
  <canvas ref="root" />
</template>
